import React, { useState, useEffect } from "react";
import HorHeader from "../../Components/HorHeader/HorHeader";
import classes from "./Dashboard.module.css";
import { NavLink, useLocation, Link } from "react-router-dom";
import Sidebar from "../../Components/Sidebar/Sidebar";
import arrowright from '../../Assets/chevron-right.png'
import searchicon from '../../Assets/search-normal.png';
import customDateIcon from '../../Assets/calendar-2.png';
import calndr from '../../Assets/calendar.png';
import eye from '../../Assets/eye.png';
import userprofle from '../../Assets/profileuser.png';

const Dashboard = () => {

  const [dateValue, setDateValue] = useState("");
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("Dashboard");

  const tabs = [
    { name: "Dashboard", path: "" },
    { name: "Employees", path: "/employees" },
    { name: "Transactions", path: "/transactions" },
    { name: "Stamp Duty", path: "/stamp-duty" },
    { name: "Filings & Returns", path: "/filings-returns" },
    { name: "Tax & Clearance", path: "/tax-clearance" },
    { name: "Generate Bill", path: "/generate-bill" },
  ];

  useEffect(() => {
    const pathToTab = {
      "/": "Dashboard",
      "/employees": "Employees",
      "/transactions": "Transactions",
      "/stamp-duty": "Stamp Duty",
      "/filings-returns": "Filings & Returns",
      "/tax-clearance": "Tax & Clearance",
      "/generate-bill": "Generate Bill",
    };
    setActiveTab(pathToTab[location.pathname] || "Dashboard");
  }, [location.pathname]);



  return (
    <div className={classes.coverbody}>
      <Sidebar />
      <div className={classes.body}>
        <HorHeader />
        <div className={classes.bodycntnt}>
          <div className={classes.hdcntnt}>
            <h1>All Posts </h1>
            <Link to={"/my-account"}>
              <button className={classes.profletxt}>
                <span className={classes.profletxtt}>Create Blog</span>
              </button>
            </Link>
          </div>
          <div className={classes.tabsall}>
            {/* Tabs */}

            {/* Tab Content */}
            <div className={classes.content}>
              <div className={classes.tablinks}>
                <p className={classes.postptg}>Post </p>
                <img src={arrowright} className={classes.arwrgt} />
                <p className={classes.allpstptg}>All Posts</p>
              </div>

              <div className={classes.searchsnfilter}>
                <div className={classes.searchContainer}>
                  <img src={searchicon} alt="search" className={classes.searchIcon} />
                  <input type="text" placeholder="Search blog" className={classes.searchBar} />
                </div>
                <div className={classes.dateInputWrapper}>
                  <input type="date" placeholder="Select date range" value={dateValue}
                    onChange={e => setDateValue(e.target.value)} className={classes.select} />
                  {!dateValue && (
                    <span className={classes.datePlaceholder}>Select date range</span>
                  )}
                  <img src={customDateIcon} alt="calendar" className={classes.customDateIcon} />
                </div>
              </div>

            </div>

            <div className={classes.entblogcontent}>
              <div>
                <div className={classes.rowblog}>
                  <div className={classes.containerblog}>
                    <p className={classes.jksktxt}>UX review presentations</p>
                    <div className={classes.blogimgandtxt}>
                      <img src={calndr} className={classes.clndrstle} />
                      <p className={classes.bloglilptxt}>20th June 2024</p>
                      <img src={eye} className={classes.eyerstle} />
                      <p className={classes.bloglilptxt}>100</p>
                    </div>
                    <p className={classes.contnt}>Ipsum sit mattis nulla quam nulla. Gravida id gravida ac enim mauris id. Non pellentesque congue eget consectetur turpis. Sapien, dictum molestie sem tempor. Diam elit, orci, tincidunt aenean tempus. Quis velit eget ut tortor tellus. Sed vel, congue felis elit erat nam nibh orci.</p>
                    <div className={classes.usrcntn}>
                      <div className={classes.usrnm}>
                        <img src={userprofle} className={classes.usrprfle}/>
                        <div className={classes.usrptg}><p >William Oharisi</p></div>
                        
                      </div>
                      <button className={classes.dtlsbtn}>View Details</button>
                    </div>
                  </div>
                  <div className={classes.containerblog}>
                    <p className={classes.jksktxt}>UX review presentations</p>
                    <div className={classes.blogimgandtxt}>
                      <img src={calndr} className={classes.clndrstle} />
                      <p className={classes.bloglilptxt}>20th June 2024</p>
                      <img src={eye} className={classes.eyerstle} />
                      <p className={classes.bloglilptxt}>100</p>
                    </div>
                    <p className={classes.contnt}>Ipsum sit mattis nulla quam nulla. Gravida id gravida ac enim mauris id. Non pellentesque congue eget consectetur turpis. Sapien, dictum molestie sem tempor. Diam elit, orci, tincidunt aenean tempus. Quis velit eget ut tortor tellus. Sed vel, congue felis elit erat nam nibh orci.</p>
                    <div className={classes.usrcntn}>
                      <div className={classes.usrnm}>
                        <img src={userprofle} className={classes.usrprfle}/>
                        <div className={classes.usrptg}><p >William Oharisi</p></div>
                        
                      </div>
                      <button className={classes.dtlsbtn}>View Details</button>
                    </div>
                  </div>
                  <div className={classes.containerblog}>
                    <p className={classes.jksktxt}>UX review presentations</p>
                    <div className={classes.blogimgandtxt}>
                      <img src={calndr} className={classes.clndrstle} />
                      <p className={classes.bloglilptxt}>20th June 2024</p>
                      <img src={eye} className={classes.eyerstle} />
                      <p className={classes.bloglilptxt}>100</p>
                    </div>
                    <p className={classes.contnt}>Ipsum sit mattis nulla quam nulla. Gravida id gravida ac enim mauris id. Non pellentesque congue eget consectetur turpis. Sapien, dictum molestie sem tempor. Diam elit, orci, tincidunt aenean tempus. Quis velit eget ut tortor tellus. Sed vel, congue felis elit erat nam nibh orci.</p>
                    <div className={classes.usrcntn}>
                      <div className={classes.usrnm}>
                        <img src={userprofle} className={classes.usrprfle}/>
                        <div className={classes.usrptg}><p >William Oharisi</p></div>
                        
                      </div>
                      <button className={classes.dtlsbtn}>View Details</button>
                    </div>
                  </div>
                </div>
                <div className={classes.rowblog2}>
                  <div className={classes.containerblog}>
                    <p className={classes.jksktxt}>UX review presentations</p>
                    <div className={classes.blogimgandtxt}>
                      <img src={calndr} className={classes.clndrstle} />
                      <p className={classes.bloglilptxt}>20th June 2024</p>
                      <img src={eye} className={classes.eyerstle} />
                      <p className={classes.bloglilptxt}>100</p>
                    </div>
                    <p className={classes.contnt}>Ipsum sit mattis nulla quam nulla. Gravida id gravida ac enim mauris id. Non pellentesque congue eget consectetur turpis. Sapien, dictum molestie sem tempor. Diam elit, orci, tincidunt aenean tempus. Quis velit eget ut tortor tellus. Sed vel, congue felis elit erat nam nibh orci.</p>
                    <div className={classes.usrcntn}>
                      <div className={classes.usrnm}>
                        <img src={userprofle} className={classes.usrprfle}/>
                        <div className={classes.usrptg}><p >William Oharisi</p></div>
                        
                      </div>
                      <button className={classes.dtlsbtn}>View Details</button>
                    </div>
                  </div>
                  <div className={classes.containerblog}>
                    <p className={classes.jksktxt}>UX review presentations</p>
                    <div className={classes.blogimgandtxt}>
                      <img src={calndr} className={classes.clndrstle} />
                      <p className={classes.bloglilptxt}>20th June 2024</p>
                      <img src={eye} className={classes.eyerstle} />
                      <p className={classes.bloglilptxt}>100</p>
                    </div>
                    <p className={classes.contnt}>Ipsum sit mattis nulla quam nulla. Gravida id gravida ac enim mauris id. Non pellentesque congue eget consectetur turpis. Sapien, dictum molestie sem tempor. Diam elit, orci, tincidunt aenean tempus. Quis velit eget ut tortor tellus. Sed vel, congue felis elit erat nam nibh orci.</p>
                    <div className={classes.usrcntn}>
                      <div className={classes.usrnm}>
                        <img src={userprofle} className={classes.usrprfle}/>
                        <div className={classes.usrptg}><p >William Oharisi</p></div>
                        
                      </div>
                      <button className={classes.dtlsbtn}>View Details</button>
                    </div>
                  </div>
                  <div className={classes.containerblog}>
                    <p className={classes.jksktxt}>UX review presentations</p>
                    <div className={classes.blogimgandtxt}>
                      <img src={calndr} className={classes.clndrstle} />
                      <p className={classes.bloglilptxt}>20th June 2024</p>
                      <img src={eye} className={classes.eyerstle} />
                      <p className={classes.bloglilptxt}>100</p>
                    </div>
                    <p className={classes.contnt}>Ipsum sit mattis nulla quam nulla. Gravida id gravida ac enim mauris id. Non pellentesque congue eget consectetur turpis. Sapien, dictum molestie sem tempor. Diam elit, orci, tincidunt aenean tempus. Quis velit eget ut tortor tellus. Sed vel, congue felis elit erat nam nibh orci.</p>
                    <div className={classes.usrcntn}>
                      <div className={classes.usrnm}>
                        <img src={userprofle} className={classes.usrprfle}/>
                        <div className={classes.usrptg}><p >William Oharisi</p></div>
                        
                      </div>
                      <button className={classes.dtlsbtn}>View Details</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Tab Content  end here*/}


          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
